import React,{useState,useEffect} from 'react'
import './GetAbout.css'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../../../firebase/Config'
function GetAbout() {
    const [aboutUs,setAboutUs]=useState([])
    const [loading,setLoading]=useState(true)
    useEffect(()=>{ 

        const fetchAboutUs=async()=>{
            const aboutUsRef=collection(db,'contact')
            const querySnapshot=await getDocs(aboutUsRef)
            const aboutUsData=querySnapshot.docs.map(doc=>({
                id:doc.id,  
                ...doc.data()
            }))
            aboutUsData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setAboutUs(aboutUsData)
            setLoading(false)
        }
        fetchAboutUs()
    },[])
   
  return (
    <div>
    <div className="container">
   <div className="text-center mt-3" >
       <h1 className="section-title title-all-users">
          Users About Us Message
       </h1>
   </div>
   
   <div className="table-responsive">
       <table className="table user-table table-striped">
           <thead>
               <tr>
                   
                   <th scope="col"> Name</th>
                   <th scope="col"> Email</th>
                   <th scope="col"> Subject</th>
                   
                   <th scope="col"> Message</th>
               </tr>
           </thead>
           <tbody>
              {aboutUs.map((about)=>(
               <tr>    
                   <th scope="row"> {about.name}</th>
                   <td class="user-email">{about.email}</td>
                   <td class="user-name">{about.subject}</td>
                <td class="user-id" style={{textAlign:'left',width:'40%'}}>{about.message}</td>
                   
                 
               </tr>
            ))}
           </tbody>
       </table>
   </div>
</div>
</div>
  )
}

export default GetAbout